export interface EmployeeDto {
  PRCo: number;
  HireDate?: Date;

  Ssn: string;
  HRRef: number;

  FirstName: string;
  LastName: string;
  MiddleName?: string;
  NameSuffix?: string;

  NickName?: string;

  DateOfBirth: Date;
  CellPhone?: string;
  AlternatePhone?: string;
  Email?: string;

  SecurityUserId?: string;
}
